<template>
  <el-container class="InboundBulkChange">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
      >
        <el-form-item prop="inbound_date" label="매입일">
          <el-checkbox v-model="selection.inbound_date" />
          <div class="inline pl-default">
            <ADatePicker
              v-model="data.inbound_date"
              @change="handleChangeInboundDate"
            />
          </div>
        </el-form-item>
        <el-form-item prop="order_date" label="발주일">
          <el-checkbox v-model="selection.order_date" />
          <div class="inline pl-default">
            <ADatePicker
              v-model="data.order_date"
              @change="handleChangeOrderDate"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="disableRegister"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "InboundBulkChange",
  data() {
    let validateInboundDate = (rule, value, callback) => {
      if (!this.selection.inbound_date || this.data.inbound_date) {
        callback();
      } else {
        callback(new Error("매입일을 선택해 주세요."));
      }
    };
    let validateOrderDate = (rule, value, callback) => {
      if (!this.selection.order_date || this.data.order_date) {
        callback();
      } else {
        callback(new Error("발주일을 선택해 주세요."));
      }
    };
    return {
      title: this.$t("title.sale"),
      selection: {
        inbound_date: false,
        order_date: false,
      },
      data: {
        inbound_date: null,
        order_date: null,
      },
      rules: {
        inbound_date: [{ validator: validateInboundDate, trigger: "blur" }],
        order_date: [{ validator: validateOrderDate, trigger: "blur" }],
      },
      load_button: false,
    };
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
  },
  computed: {
    disableRegister() {
      return !this.selection.inbound_date && !this.selection.order_date;
    },
  },
  methods: {
    doRegister() {
      let data = {};
      if (this.selection.inbound_date) {
        data.inbound_date = this.data.inbound_date;
      }
      if (this.selection.order_date) {
        data.order_date = this.data.order_date;
      }
      let param = {
        ids: this.ids,
        data: data,
      };
      this.load_button = true;
      this.api.updateInboundBulk(param).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed", true);
      });
    },
    handleChangeInboundDate() {
      this.selection.inbound_date = !!this.data.inbound_date;
    },
    handleChangeOrderDate() {
      this.selection.order_date = !!this.data.order_date;
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },
};
</script>
